// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1NrcG","checkboxCol":"Table_checkboxCol__3zdru","emailCol":"Table_emailCol__1Qmdn","actionCol":"Table_actionCol__2yjDN"};